import React, {useMemo} from "react";
import {Field} from "react-final-form";
import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {
    UserTenthTwelfthPassingBoard,
    IdLabelInterface,
} from "../../../../containers/RegistrationLoginPage/types";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface TenthTwelthBoardInterface {
    configuration: UserTenthTwelfthPassingBoard;
}

const TenthTwelthBoard: React.FC<TenthTwelthBoardInterface> = ({
    configuration,
}: TenthTwelthBoardInterface) => {
    const {selectedValue, values, fieldName} = configuration;
    const newClass =
        useSelector(
            (state: RootStore) => state.RegistrationLoginPage.bachelorFields?.currentClass,
        ) ?? "10";
    const defaultValue = selectedValue ? selectedValue.selectedValue : null;

    return useMemo(() => {
        return (
            <Field<IdLabelInterface>
                name={fieldName}
                key={`${fieldName}_${newClass}`}
                validate={composeValidators(
                    regRequiredValidate(`Please select class ${newClass}th board`),
                )}
                validateFields={[]}
                {...(defaultValue ? {initialValue: defaultValue} : {})}
            >
                {(props) => {
                    return (
                        <SelectV2
                            placeholder={`Class ${newClass}th Board`}
                            type={SINGLE_SELECT}
                            items={values ?? []}
                            inputRFF={props.input}
                            withSearch={true}
                            isFocused={props?.meta?.active ?? false}
                            isTouched={props?.meta?.touched}
                            error={errorHandler(props?.meta)}
                            selectedOption={[props.input?.value] ?? [defaultValue]}
                            isFilled={typeof props.input.value === "object"}
                        />
                    );
                }}
            </Field>
        );
    }, [fieldName, defaultValue, newClass, values]);
};

export default TenthTwelthBoard;
